if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        if (!mediaId) return;

        const activeSlide = this.querySelector(`[id^="Slide-ProductModal-"][data-media-id="${mediaId}"]`);
        if (!activeSlide) return;

        const track = this.querySelector('[id^="Slider-ProductModal-"]');
        if (track) {
          track.scrollTo({ left: activeSlide.offsetLeft, behavior: 'instant' });
        }

        const deferredMedia = activeSlide.querySelector('deferred-media');
        const activeMediaTemplate = deferredMedia ? deferredMedia.querySelector('template') : null;
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (deferredMedia && activeMediaContent && activeMediaContent.querySelector('.js-youtube')) {
          deferredMedia.loadContent();
        }
      }
    }
  );
}
